// AURYMED image-copy deterrent. This is not DRM and cannot prevent screenshots.
(() => {
  const isProtectedImage = (target) => target instanceof Element && !!target.closest('img, picture, .product-media-container, .product-media-gallery');

  document.addEventListener('contextmenu', (event) => {
    if (isProtectedImage(event.target)) event.preventDefault();
  }, { capture: true });

  document.addEventListener('dragstart', (event) => {
    if (isProtectedImage(event.target)) event.preventDefault();
  }, { capture: true });
})();
